var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardUparrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7.41,
    viewBox: "0 0 12 7.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Chivron_Up",
    "data-name": "Chivron Up",
    d: "M7.41,15.41,12,10.83l4.59,4.58L18,14,12,8,6,14Z",
    transform: "translate(-6 -8)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardUparrowIcon);
export default __webpack_public_path__ + "static/media/keyboard-uparrow-icon.fa4c5fbe8ffd67e01709a67fc030eb09.svg";
export { ForwardRef as ReactComponent };